<template>
    <div>
      <FormulaBanner :title="title" :formulaCode="formulaCode"/>
      <div class="index">
        <!-- 表单 -->
        <div>
          <div class="top_nav"><span></span>{{title}}
          </div>
          <div class="formBody">
            <!-- 表单 -->
            <MyPatient :memberId="memberId" :selectValue="selectValue" @change="userChange"/>
            <TemplateFiveList :type="'radio'" :list-data="list5Data" :selectValue="list5Select" @change="list5Change"></TemplateFiveList>
            <TemplateFiveList :type="'radio'" :list-data="list1Data" :selectValue="list1Select" @change="list1Change"></TemplateFiveList>
            <TemplateFiveList :type="'radio'" :list-data="listData" :selectValue="listSelect" @change="listChange"></TemplateFiveList>
            <div v-if="compute === true" style="margin: 16px;display: flex;justify-content: center;">
              <van-button class="formula-template-button" block type="info" @click="submit" style="width:90px">提交</van-button>
            </div>
          </div>
        </div>
        <CalculationResults :countText="countValue" :countTextList="countTextList" v-if="show"></CalculationResults>
        <!-- 后台设置的值 -->
        <FormulaExplain :explain-data="tableData.explain"></FormulaExplain>
        <!-- 参考文献 -->
        <FormulaReferences :references-data="tableData.references"></FormulaReferences>
      </div>
  
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
            title="应激指数"
            show-toolbar
            :columns="columns"
            @confirm="onConfirm"
            @cancel="onCancel"
        />
      </van-popup>
  
    </div>
  
  </template>
  
  <script>
  import MyPatient from '@/components/MyPatient.vue'
  import FormulaBanner from '@/components/FormulaBanner.vue'
  import {Toast} from "vant";
  import {getAdmins} from "@/utils/adminDate";
  import {setById} from "@/service/base";
  import {getFormula, getFormulaHuiXian, postFormula} from "@/service/BodyMassIndex_api";
  import FormulaExplain from "@/components/template1/FormulaExplain";
  import FormulaReferences from "@/components/template1/FormulaReferences";
  import TemplateFiveList from "@/components/Template5/TemplateFiveList";
  import CalculationResults from "@/components/CalculationResults";
  export default {
    name: "medicalSearch",
    data(){
      return{
        compute:true,
        countTextList:[],
        show:false,
        countValue:"",
        listSelect: [],
        listData: [
          {
            title: '收缩压（mmHg）',
            columns: ['>100','80-100','70-80','<70'],
            fenzhi: [0,2,3,4] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '脉搏>收缩压',
            columns: ['是','否'],
            fenzhi: [2,0] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
           {
            title: '体温<35℃或者≥39℃',
            columns: ['是','否'],
            fenzhi: [2,0] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '呼吸率(次/min)',
            columns: ['≤20','20-30','>30'],
            fenzhi: [0,1,2] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '血氧饱和度',
            columns: ['≥95%','90%-95%','<90%'],
            fenzhi: [0,1,2] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '抱怨呼吸困难',
            columns: ['是','否'],
            fenzhi: [1,0] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '心电图有异常（不包括心动过速或心动过缓）',
            columns: ['是','否'],
            fenzhi: [2,0] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '糖尿病(类型Ⅰ或Ⅱ)',
            columns: ['是','否'],
            fenzhi: [1,0] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '没有中毒或药物过量的昏迷',
            columns: ['是','否'],
            fenzhi: [4,0] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '精神状态改变，无昏迷、中毒或过量饮酒（≥50岁)',
            columns: ['是','否'],
            fenzhi: [2,0] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '新近中风',
            columns: ['是','否'],
            fenzhi: [3,0] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '无法独自站立，或需要人护理',
            columns: ['是','否'],
            fenzhi: [2,0] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '存在某些需白天卧床的既往疾病',
            columns: ['是','否'],
            fenzhi: [2,0] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
        ],
        list1Data:[],
        list1Select: [],
        formulaCode: '',
        shengao: '',
        yingjizhishu: '',
        title: '',
        memberId: '1111',
        selectValue: '',
        username:"",
        value:"",
        showPopover: false,
        showPicker: false,
        columns: ['', '', '',''],
        nianling: '',
        xingbie: null,
        tableData: {},
        countText: '',
        patientId: null,
        result: null,
        yingjizhishuzhi: '',
        tizhong: '',
        xueqingnanongdu: '',
        oneREsult:null,
        fenzhiList: [],
        fenzhi1List:[],
        list5Data: [
          {
            title: '性别',
            columns: ['男','女'],
            fenzhi: [0,0] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
        ],
        list5Select: [],
        fenzhi5List:[],
      }
    },
    components: {
      FormulaBanner,
      MyPatient,
      FormulaExplain,
      FormulaReferences,
      TemplateFiveList,
      CalculationResults
    },
    async created() {
      await this.test()
      await this.getTableData()
    },
  
    methods:{
      list5Change (result, fenzhi) {
        // this.fenzhiList = []
        this.show=false
        this.list5Select = result //结果数组
        this.fenzhi5List = fenzhi  //分值数组
        if (result.some(item => item.value[0] === "男")) {
            // <50   +0分；50-75   2分；>75    +4分
          this.list1Data = [
            {
              title: '年龄（岁）',
              columns: ['<50','50-75','>75'],
              fenzhi: [0,2,4] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
            }
          ]
        } else if (result.some(item => item.value[0] === "女")) {
            // <55   +0分；55-75   2分；>75    +4分
          this.list1Data = [
            {
              title: '年龄（岁）',
              columns: ['<55','55-75','>75'],
              fenzhi: [0,2,4] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
            }
          ]
        }
        this.list1Select = []
        this.fenzhi1List = []
        // console.log("分值",this.list1Select,this.fenzhi1List)
      },
      listChange (result, fenzhi) {
        // this.fenzhiList = []
        this.show=false
        this.listSelect = result //结果数组
        this.fenzhiList = fenzhi  //分值数组
        // console.log("长的分值",this.listSelect,this.fenzhiList)
      },
      list1Change (result, fenzhi) {
        // this.fenzhiList = []
        this.show=false
        this.list1Select = result //结果数组
        this.fenzhi1List = fenzhi  //分值数组
        // console.log("分值",result,fenzhi)
      },
      coumputTetxt () {
        let fenshu = 0
        for (let i = 0; i < this.fenzhiList.length; i++) {
          fenshu += this.fenzhiList[i]
        }
        this.oneREsult = fenshu 
        for (let i = 0; i < this.fenzhi1List.length; i++) {
          fenshu += this.fenzhi1List[i]
        }
        this.result = fenshu 
        if( fenshu  <= 7){
          this.countValue = `${fenshu}分 低危`
        }else if(fenshu  >= 8 && fenshu  <= 11){
          this.countValue = `${fenshu}分 高危` 
        }else if(fenshu  >= 12){
          this.countValue = `${fenshu}分 极高危` 
        }
        this.show = true
      },
      async test(){
        //像接口头部传用户信息
        let arrays = await getAdmins(this.$route.query.memberId,this.$route.query.channel)
        this.channel = arrays.os
        this.version = arrays.version
        this.ip = arrays.ip
        await setById(arrays)
      },
      async getTableData () {
        const data = {
          channel: this.$router.currentRoute.query.channel,
          code: 'NJMJSTIB',
        }
        const res = await getFormula(data.channel, data.code)
        if (res.code === 0) {
          this.tableData = res.data
          this.formulaCode = res.data.code
          this.title = res.data.chineseName
        }
        if (this.$router.currentRoute.query.location === 'YXGS_RECORD_LIST' && this.$router.currentRoute.query.logId) {
          // this.compute = false
          const data = {
            id: this.$router.currentRoute.query.logId
          }
          const res = await getFormulaHuiXian(data)
          if (res.code === 0) {
            console.log("选项", res.data)
            if (res.data.content.da5ta.some(item => item.value[0] === "男")) {
              this.list1Data = [
                {
                  title: '年龄（岁）',
                  columns: ['<50','50-75','>75'],
                  fenzhi: [0,2,4] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
                }
              ]
            } else if (res.data.content.da5ta.some(item => item.value[0] === "女")) {
              this.list1Data = [
                {
                  title: '年龄（岁）',
                  columns: ['<55','55-75','>75'],
                  fenzhi: [0,2,4] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
                }
              ]
            }
            this.listSelect = res.data.content.data
            this.list1Select = res.data.content.da1ta
            this.list5Select = res.data.content.da5ta     
            if (res.data.patientId) this.selectValue = {id: res.data.patientId, name: res.data.patientName}
            this.fenzhiList = [res.data.result.va1lue]
            this.fenzhi1List = [res.data.result.va2lue]
            this.oneREsult = res.data.result.va1lue
            this.result = res.data.result.va2lue
            this.countText = res.data.result.result
            this.countValue=res.data.result.DisplayResults
            this.show=true
          }
        }
      },
      async submit () {
        // console.log("选项", this.list5Select.length !== 1,this.listSelect.length !== 6,this.list1Select.length !== 2)
        if (this.list5Select.length !== 1 || this.listSelect.length !== 13 || this.list1Select.length !== 1) {
          Toast.fail('请完善选择')
          return
        }
        this.coumputTetxt()
        const data = {
          id: this.$router.currentRoute.query.location === 'YXGS_RECORD_LIST' ? this.$router.currentRoute.query.logId : null,
          patientId: this.patientId,
        //   columnCode: this.tableData.columnCode,
          columnCode: 'JZZYX',
          formulaCode: this.tableData.code,
          channel: this.$router.currentRoute.query.channel,
          location: this.$router.currentRoute.query.location,
          content: {
            data: this.listSelect,
            da1ta: this.list1Select,
            da5ta: this.list5Select,
            // xueqingnanongdu: {value: this.xueqingnanongdu, unit: 'mmol/L'},
          },
          result: {
            va1lue:this.oneREsult,
            va2lue:this.result,
            result: this.countText,
            DisplayResults:this.countValue
          }
        }
        const res = await postFormula(data)
        if (res.code === 0) {
          Toast.success('提交成功')
        } else {
          Toast.fail(res.message)
        }
      },
      calculateAge(birthDateString) {
        const today = new Date();
        const birthDate = new Date(birthDateString);
        let age = today.getFullYear() - birthDate.getFullYear();
        // 如果今天的日期还没到生日月份和日期，则年龄减一
        if (today.getMonth() < birthDate.getMonth() ||
            (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())) {
          age--;
        }
        return age;
      },
      // 开参考文献链接
      openLink(u){
        if (!u) {
          return
        }
        //获取系统版本
        let userAI = navigator.userAgent;
        const isAndroid = userAI.indexOf('Android') > -1 || userAI.indexOf('Linux') > -1; //Android终端
        const isIOS = !!userAI.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
        if (isAndroid) {
          // alert('安卓操作系统')
          // 这个是安卓操作系统
          window.open(u)
        }
        if (isIOS) {
          // 这个是ios操作系统
          // alert('ios操作系统')
          window.location.href = u
        }
      },
      yingjiClick () {
        this.showPicker = true
      },
      onConfirm(value) {
        this.yingjizhishu = value
        this.showPicker = false
      },
      onCancel() {
        this.showPicker = false
      },
      userChange (data) {
        if (data.birthday && data.birthday !== '') {
          this.nianling = this.calculateAge(data.birthday)
        } else {
          this.nianling = ''
        }
        this.xingbie = data.sex
        this.patientId = data.id
        this.selectValue = data
      },
    }
  }
  </script>
  
  
  <style scoped lang="scss">
  .index{
    background: #F6F6F6;
    padding: 10px 15px;
    min-height: 100vh;
    .StandardDescription{
      margin-top:10px;
      .top_nav{
        font-size: 16px;
        color: #333333;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: start;
        margin-bottom:10px;
        span {
          display: inline-block;
          width: 5px;
          height: 15px;
          background: #259beb;
          margin-right: 5px;
        }
      }
      .StandardDeatil{
        width:100%;
        padding:15px 10px;
        //   height: 50px;
        background-color: #fff;
        box-sizing: border-box;
      }
    }
    .top_nav{
      font-size: 16px;
      color: #333333;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: start;
      margin-bottom:10px;
      span {
        display: inline-block;
        width: 5px;
        height: 15px;
        background: #259beb;
        margin-right: 5px;
      }
    }
    .formBody{
      background-color: #fff;
      padding-bottom:10px;
      .CalculationResultsBox{
        padding:0 8px;
        .CalculationResults{
          font-size: 16px;
          color: #333333;
          font-weight: bold;
          display: flex;
          justify-content: center;
          margin-bottom:10px
        }
        .CalculationDetail{
          font-size: 15px;
          color: #333333;
          // font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: start;
          margin-bottom:10px;
          background-color: #f6f6f6;
          // height: 16px;
          span{
            display: inline-block;
            width: 3px;
            height: 24px;
            background: #fe9712;
            margin-right: 5px;
          }
        }
      }
    }
    .titles{
      display:flex;
      align-items: center;
      justify-content: space-between;
      width:100%;
      height: 50px;
      border-bottom: 1px solid #f0f0f0;
      padding: 0 10px;
      box-sizing: border-box;
      .titlesName{
        font-size:16px;
        i{
          color: red;
        }
      }
      .information{
        font-size:16px;
        margin-right:4px;
        .PleaseSelect{
          color: #b9b9b9;
        }
        .vanCell{
          width:50px;
          padding:0;
          height: 100%;
        }
      }
      .vBotton{
        width:60px
      }
      .unit{
        height: 50px;
        //   line-height: 50px;
        display: flex;
        align-items: center;
        font-size:16px;
        width:20px;
      }
      .vanIcon{
        font-size:13px;
        color:#a8a8a8;
        font-weight: 650;
      }
    }
  }
  ::v-deep .van-cell {
    padding:0px 0px;
  }
  ::v-deep .van-field__control{
    height: 50px;
    font-size: 16px;
  }
  ::v-deep .van-field__error-message {
    position: absolute;
    top: 30px;
    left: 10px;
  }
  .StandardDeatil2{
    width:100%;
    padding: 15px 10px;
    padding-bottom:1px;
    //   height: 50px;
    background-color: #fff;
    box-sizing: border-box;
    .references{
      margin-bottom:15px
    }
  }
  ::v-deep p {
    padding: 0;
    margin: 0;
  }
  .Abutton {
  
  }
  </style>
  